import { graphql } from 'gatsby';

/**
 * @param {any} props
 * @param {string} locale
 */
export const tableMapping = (props, locale) => {
  let suffix = '_en';
  if (locale === 'es') {
    suffix = '_es';
  }
  return {
    title: props['title' + suffix],
    disclaimer: props['disclaimer' + suffix],
    items: props?.[`items_${locale}`].map((item) => ({
      title: item.title,
      description: item.description,
    })),
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Table on StrapiWidgetrels {
    table {
      key: id
      title_en
      title_es
      disclaimer_en
      disclaimer_es
      items_en {
        title
        description
      }
      items_es {
        title
        description
      }
      widgetPosition
    }
  }
`;
